import { Accordion, AccordionSummary, Alert, useTheme } from '@methanesat/ui-components';
import { ReactNode } from 'react';

const defaultCursorSX = { cursor: 'default' };

export const EmissionAccordionFallback = ({ content }: { content: string | ReactNode | ReactNode[] }) => {
    const theme = useTheme();
    return (
        <Accordion sx={[theme.mixins.emissionAccordion]} elevation={0} disableGutters expanded={false}>
            <AccordionSummary
                sx={{
                    ...defaultCursorSX,
                    '&:hover:not(.Mui-disabled)': defaultCursorSX,
                    '& *': defaultCursorSX
                }}
            >
                <Alert severity="error" sx={{ width: '100%' }}>
                    {content}
                </Alert>
            </AccordionSummary>
        </Accordion>
    );
};
